import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { reviews } from '@/mocks/comics';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-50 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto px-4 md:px-8 py-4">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>
        </div>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-8">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-3 text-center">
              关于汗汗漫画
            </h1>
            <p className="text-sm text-foreground-500 text-center mb-10 max-w-xl mx-auto">
              最新最全韩漫免费在线观看平台
            </p>

            <div className="bg-background-100 rounded-xl p-6 md:p-8 mb-10">
              <h2 className="text-lg font-bold text-foreground-950 mb-4 flex items-center gap-2">
                <i className="ri-building-line text-primary-500"></i>
                品牌介绍
              </h2>
              <div className="text-sm text-foreground-600 leading-relaxed space-y-3">
                <p>
                  汗汗漫画成立于2024年，是一个专注于韩国漫画（韩漫）在线阅读的中文平台。我们致力于为广大华语韩漫爱好者提供<strong>最新、最全</strong>的韩漫资源，打造一个<strong>实时更新、覆盖无死角</strong>的韩漫大全内容库。
                </p>
                <p>
                  我们的团队由一群热爱漫画的年轻人组成，深知追漫的快乐和寻找资源的烦恼。因此，汗汗漫画始终坚持<strong>免费在线观看</strong>的宗旨，让每一位漫友都能零门槛享受高质量韩漫阅读体验。
                </p>
                <p>
                  平台收录了涵盖恋爱、奇幻、动作、耽美、悬疑、搞笑、剧情、恐怖、古风、校园、职场等十余种分类的数千部韩漫作品。无论你是喜欢甜宠恋爱还是热血冒险，都能在汗汗漫画找到心仪的漫画。
                </p>
                <p>
                  我们与多家韩漫汉化组保持密切合作，确保在第一时间为读者带来最新的汉化更新。同时，我们也在不断优化阅读体验，让漫画加载更快、画质更清晰。
                </p>
              </div>
            </div>

            <div className="bg-background-100 rounded-xl p-6 md:p-8 mb-10">
              <h2 className="text-lg font-bold text-foreground-950 mb-6 flex items-center gap-2">
                <i className="ri-star-smile-line text-accent-500"></i>
                用户评价
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {reviews.map((review) => (
                  <div key={review.id} className="bg-background-50 rounded-lg p-5">
                    <div className="flex items-center gap-3 mb-3">
                      <img
                        src={review.avatar}
                        alt={review.name}
                        className="w-10 h-10 rounded-full object-cover"
                      />
                      <div>
                        <p className="text-sm font-semibold text-foreground-950">{review.name}</p>
                        <p className="text-xs text-foreground-400">{review.date}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-0.5 mb-2">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-400 text-xs"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">{review.content}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-background-100 rounded-xl p-6 md:p-8 mb-10">
              <h2 className="text-lg font-bold text-foreground-950 mb-6 flex items-center gap-2">
                <i className="ri-mail-send-line text-secondary-500"></i>
                联系我们
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-3">联系方式</h3>
                  <ul className="space-y-3 text-sm text-foreground-600">
                    <li className="flex items-center gap-2">
                      <i className="ri-mail-line text-primary-500"></i>
                      <span>contact@hanhancomic.com</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-global-line text-accent-500"></i>
                      <span>https://hanhancomic.com</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-time-line text-foreground-400"></i>
                      <span>工作日 9:00 - 18:00</span>
                    </li>
                  </ul>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-3">给我们留言</h3>
                  <form
                    className="space-y-3"
                    data-readdy-form
                    id="contact-form"
                    onSubmit={async (e) => {
                      e.preventDefault();
                      const form = e.currentTarget;
                      const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
                      if (honeypot) {
                        const msgEl = document.getElementById('form-msg');
                        if (msgEl) { msgEl.textContent = '留言已提交，感谢您的反馈！'; msgEl.className = 'text-sm text-accent-600 mt-2'; }
                        form.reset();
                        return;
                      }
                      const formData = new FormData(form);
                      formData.delete('website_alt');
                      const urlEncoded = new URLSearchParams();
                      formData.forEach((v, k) => urlEncoded.append(k, v as string));
                      try {
                        const res = await fetch('https://readdy.ai/api/form/d9pboigsenbniolesse0', {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                          body: urlEncoded.toString(),
                        });
                        const responseText = await res.text();
                        let parsed: any;
                        try { parsed = JSON.parse(responseText); } catch (_) { parsed = null; }
                        const msgEl = document.getElementById('form-msg');
                        if (res.ok && parsed?.code === 'OK') {
                          if (msgEl) { msgEl.textContent = '留言已提交，感谢您的反馈！'; msgEl.className = 'text-sm text-accent-600 mt-2'; }
                          form.reset();
                        } else {
                          const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || '提交失败，请稍后重试';
                          if (msgEl) { msgEl.textContent = serverMsg; msgEl.className = 'text-sm text-primary-500 mt-2'; }
                        }
                      } catch (_) {
                        const msgEl = document.getElementById('form-msg');
                        if (msgEl) { msgEl.textContent = '网络错误，请稍后重试'; msgEl.className = 'text-sm text-primary-500 mt-2'; }
                      }
                    }}
                  >
                    <input
                      type="text"
                      name="website_alt"
                      className="honeypot-field"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                    />
                    <input
                      type="text"
                      name="name"
                      placeholder="您的昵称"
                      className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200 bg-background-50 outline-none focus:border-primary-300 transition-colors"
                      required
                    />
                    <input
                      type="email"
                      name="email"
                      placeholder="您的邮箱"
                      className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200 bg-background-50 outline-none focus:border-primary-300 transition-colors"
                      required
                    />
                    <textarea
                      name="message"
                      placeholder="请输入您的留言..."
                      rows={3}
                      maxLength={500}
                      className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200 bg-background-50 outline-none focus:border-primary-300 transition-colors resize-none"
                      required
                    ></textarea>
                    <button
                      type="submit"
                      className="px-6 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      发送留言
                    </button>
                    <div id="form-msg"></div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于汗汗漫画 - 最新最全韩漫免费在线观看平台',
            description: '汗汗漫画致力于提供最新最全的韩漫资源，全部支持免费在线观看，打造一个实时更新、覆盖无死角的韩漫大全内容库。',
            mainEntity: {
              '@type': 'Organization',
              name: '汗汗漫画',
              url: 'https://hanhancomic.com/',
              description: '汗汗漫画致力于提供最新最全的韩漫资源，全部支持免费在线观看。',
              contactPoint: {
                '@type': 'ContactPoint',
                email: 'contact@hanhancomic.com',
                contactType: 'customer service',
                availableLanguage: ['Chinese'],
              },
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '汗汗漫画是什么？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '汗汗漫画是一个专注于韩国漫画（韩漫）在线阅读的中文平台，提供最新最全的韩漫资源，全部支持免费在线观看。',
                },
              },
              {
                '@type': 'Question',
                name: '汗汗漫画需要付费吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '不需要。汗汗漫画始终坚持免费在线观看的宗旨，所有韩漫作品均可免费阅读，无需注册付费。',
                },
              },
              {
                '@type': 'Question',
                name: '汗汗漫画有哪些类型的韩漫？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '汗汗漫画涵盖了恋爱、奇幻、动作、耽美、悬疑、搞笑、剧情、恐怖、古风、校园、职场等多种分类的韩漫作品，满足不同读者的喜好。',
                },
              },
              {
                '@type': 'Question',
                name: '汗汗漫画的更新速度快吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '是的。汗汗漫画与多家韩漫汉化组保持密切合作，确保在第一时间为读者带来最新的汉化更新。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}